import { ReactNode } from "react";

export type BadgeVariant = "neutral" | "success" | "warning" | "error" | "info";

interface BadgeProps {
  variant: BadgeVariant;
  children: ReactNode;
  className?: string;
}

export default function Badge({
  variant,
  children,
  className = "",
}: BadgeProps) {
  const variantStyles = {
    info: "bg-blue-50 text-blue-700 border border-blue-300",
    warning: "bg-yellow-100 text-yellow-800 border border-yellow-400",
    success: "bg-green-50 text-green-700 border border-green-300",
    error: "bg-red-50 text-red-700 border border-red-300",
    neutral: "bg-gray-100 text-gray-700 border border-gray-400",
  };

  return (
    <span
      className={`inline-block px-2 py-1 rounded text-xs font-medium ${variantStyles[variant]} ${className}`}
    >
      {children}
    </span>
  );
}
